// extracted by mini-css-extract-plugin
export default {"breakpointxs":"0","order-p-med":"OrderPMed_order-p-med__SUDOj","order-p-med__header":"OrderPMed_order-p-med__header__6jrey"};